var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFourPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:star-four-points"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 1L4.5 5L0.5 6.5L4.5 8L6 12L7.5 8L11.5 6.5L7.5 5L6 1Z",
    fill: "#A6AFCE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFourPoints);
export default __webpack_public_path__ + "static/media/star-four-points.611209a231e3b0c5bde4e2f685e4f922.svg";
export { ForwardRef as ReactComponent };